export default function Logo({ size = 40, withWordmark = true, light = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="ucp-logo">
      <div
        className="relative flex items-center justify-center rounded-2xl shadow-lg shadow-violet-500/30"
        style={{
          width: size, height: size,
          background: "linear-gradient(140deg, #A78BFA 0%, #7C3AED 45%, #5B21B6 100%)",
        }}
      >
        <span
          className="text-white font-display font-extrabold tracking-tight"
          style={{ fontSize: size * 0.3 }}
        >
          UCP
        </span>
        <div
          className="absolute -top-1 -right-1 rounded-full border-2 border-white"
          style={{ width: size * 0.26, height: size * 0.26, background: "#00D4FF" }}
        />
      </div>
      {withWordmark && (
        <div className="leading-tight">
          <div className={`font-display font-bold text-sm tracking-wide ${light ? "text-[#0A2540]" : "text-white"}`}>
            Union Crypto Private
          </div>
          <div className={`text-[10px] uppercase tracking-[0.22em] ${light ? "text-violet-600" : "text-violet-400/90"}`}>
            Private Wealth
          </div>
        </div>
      )}
    </div>
  );
}
